import React from 'react';
import { useLanguage } from '../context/LanguageContext';

const SuccessStories: React.FC = () => {
  const { t } = useLanguage();

  return (
    <section id="success-stories" className="success-stories">
      <div className="success-stories-content">
        <h2>{t('successStories.title')}</h2>
        <div className="stories-grid">
          <div className="story-card">
            <div className="story-image">
              <div className="image-placeholder">👩</div>
            </div>
            <div className="story-content">
              <h3>{t('successStories.sarah.name')}</h3>
              <p>"{t('successStories.sarah.quote')}"</p>
              <div className="story-stats">
                <span>{t('successStories.sarah.stat1')}</span>
                <span>{t('successStories.sarah.stat2')}</span>
              </div>
            </div>
          </div>
          <div className="story-card">
            <div className="story-image">
              <div className="image-placeholder">👨</div>
            </div>
            <div className="story-content">
              <h3>{t('successStories.michael.name')}</h3>
              <p>"{t('successStories.michael.quote')}"</p>
              <div className="story-stats">
                <span>{t('successStories.michael.stat1')}</span>
                <span>{t('successStories.michael.stat2')}</span>
              </div>
            </div>
          </div>
          <div className="story-card">
            <div className="story-image">
              <div className="image-placeholder">👩</div>
            </div>
            <div className="story-content">
              <h3>{t('successStories.emma.name')}</h3>
              <p>"{t('successStories.emma.quote')}"</p>
              <div className="story-stats">
                <span>{t('successStories.emma.stat1')}</span>
                <span>{t('successStories.emma.stat2')}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SuccessStories; 